"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var styles = {
  root: {
    margin: '15px 10px'
  },
  label: {
    fontSize: '12px',
    textAlign: function textAlign(_ref) {
      var labelPosition = _ref.labelPosition;
      return labelPosition === 'left' ? 'right' : 'auto';
    },
    "float": function float(_ref2) {
      var labelPosition = _ref2.labelPosition;
      return labelPosition === 'left' ? 'left' : 'auto';
    },
    width: function width(_ref3) {
      var labelPosition = _ref3.labelPosition;
      return labelPosition === 'left' ? '30px' : 'auto';
    },
    margin: function margin(_ref4) {
      var labelPosition = _ref4.labelPosition;
      return "".concat(labelPosition === 'left' ? 12 : 5, "px 5px");
    }
  },
  inputs: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};
var _default = styles;
exports["default"] = _default;